// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from "element-ui"
import 'element-ui/lib/theme-chalk/index.css'
import axios from "axios"
import Menu from "./components/meun"
import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)
Vue.config.productionTip = false

// use

Vue.use(ElementUI);

Vue.prototype.axios = axios;

Vue.component("Menu", Menu, {
  props: ["activeIndex"]
});
axios.defaults.timeout = 5000;
//axios.defaults.baseURL = "https://console.sorenenglish.com/api";
// console.log(`${location.protocol}//${location.host}/api` )
//axios.defaults.baseURL = "http://localhost:8088/api";
//axios.defaults.baseURL = "https://snow.qdxingao.com/api";
axios.defaults.baseURL = "https://houtai.guanqimiao.cn/api";

axios.defaults.headers.post["Content-Type"] =  "application/x-www-form-urlencoded";
// http response interceptors
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      console.log(error.response.status);
    }
    return Promise.reject(error.response.data);
  }
);

// http request interceptors
axios.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

// 登录验证
Vue.prototype.ifLogin = function() {
  var self = this;
   self
     .$alert("登录已失效，请重新登陆！", "提示1", {
       confirmButtonText: "确定",
       type: "warning",
       center: true,
       showClose: false,
       showCancelButton: false,
       roundButton:true
     })
     .then(() => {
       self.$router.push({ path: "/" });
     });
};
// 登录验证
Vue.prototype.ifHavemark = function () {
  var self = this;
  if (localStorage.getItem('mark')){
    //TODO 3-31 这里还能在加入token,然后发送token进行鉴权
  }else{
    self
    .$alert("登录已失效，请重新登陆！", "提示2", {
      confirmButtonText: "确定",
      type: "warning",
      center: true,
      showClose: false,
      showCancelButton: false,
      roundButton: true
    })
    .then(() => {
      self.$router.push({ path: "/" });
    });
  }

};
// 退出登录
Vue.prototype.webBack = function() {
  var self = this;
  self
    .axios({
      url: "/logout",
      method: "post"
    })
    .then(function(response) {
     // console.log(response);
      self.$message({
        message: "退出成功", type: "success",
      });
      localStorage.removeItem("mark");
      self.$router.push({ path: "/" });
    })
    .catch(function(error) {
      console.log(error);
    });

};



// WEBPACK FOOTER //
// ./src/main.js